// <script src="//shopfy-features.myshopify.com/cdn/shop/t/2/assets/b__zarano-paris.js" defer="defer"></script>
console.log('feature')